export const soundService = {
    playPulseSound: () => {
        const audio = new AudioContext();
        const osc = audio.createOscillator();
        const gain = audio.createGain();

        osc.connect(gain);
        gain.connect(audio.destination);

        osc.type = 'sine';
        osc.frequency.setValueAtTime(880, audio.currentTime);
        osc.frequency.exponentialRampToValueAtTime(440, audio.currentTime + 0.1);

        gain.gain.setValueAtTime(0.5, audio.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.01, audio.currentTime + 0.1);

        osc.start();
        osc.stop(audio.currentTime + 0.1);

        // Echo
        setTimeout(() => {
            const osc2 = audio.createOscillator();
            const gain2 = audio.createGain();
            osc2.connect(gain2);
            gain2.connect(audio.destination);
            osc2.frequency.setValueAtTime(880, audio.currentTime);
            gain2.gain.setValueAtTime(0.2, audio.currentTime);
            gain2.gain.exponentialRampToValueAtTime(0.01, audio.currentTime + 0.1);
            osc2.start();
            osc2.stop(audio.currentTime + 0.1);
        }, 150);
    },

    playLoveSound: () => {
        const audio = new AudioContext();
        const osc = audio.createOscillator();
        const gain = audio.createGain();

        osc.connect(gain);
        gain.connect(audio.destination);

        osc.type = 'triangle';
        osc.frequency.setValueAtTime(440, audio.currentTime);
        osc.frequency.linearRampToValueAtTime(554.37, audio.currentTime + 0.1); // C#
        osc.frequency.linearRampToValueAtTime(659.25, audio.currentTime + 0.2); // E

        gain.gain.setValueAtTime(0.3, audio.currentTime);
        gain.gain.linearRampToValueAtTime(0, audio.currentTime + 0.4);

        osc.start();
        osc.stop(audio.currentTime + 0.4);
    },

    playWarningSound: () => {
        const audio = new AudioContext();
        const osc = audio.createOscillator();
        const gain = audio.createGain();

        osc.connect(gain);
        gain.connect(audio.destination);

        osc.type = 'sawtooth';
        osc.frequency.setValueAtTime(200, audio.currentTime);
        osc.frequency.linearRampToValueAtTime(100, audio.currentTime + 0.3);

        gain.gain.setValueAtTime(0.5, audio.currentTime);
        gain.gain.linearRampToValueAtTime(0, audio.currentTime + 0.3);

        osc.start();
        osc.stop(audio.currentTime + 0.3);

        // Repeat for urgency
        setTimeout(() => {
            const osc2 = audio.createOscillator();
            const gain2 = audio.createGain();
            osc2.connect(gain2);
            gain2.connect(audio.destination);
            osc2.type = 'sawtooth';
            osc2.frequency.setValueAtTime(200, audio.currentTime);
            osc2.frequency.linearRampToValueAtTime(100, audio.currentTime + 0.3);
            gain2.gain.setValueAtTime(0.5, audio.currentTime);
            gain2.gain.linearRampToValueAtTime(0, audio.currentTime + 0.3);
            osc2.start();
            osc2.stop(audio.currentTime + 0.3);
        }, 300);
    },

    playCheckSound: () => {
        const audio = new AudioContext();
        const osc = audio.createOscillator();
        const gain = audio.createGain();

        osc.connect(gain);
        gain.connect(audio.destination);

        osc.type = 'sine';
        osc.frequency.setValueAtTime(500, audio.currentTime);
        osc.frequency.setValueAtTime(1000, audio.currentTime + 0.1);

        gain.gain.setValueAtTime(0.3, audio.currentTime);
        gain.gain.linearRampToValueAtTime(0, audio.currentTime + 0.2);

        osc.start();
        osc.stop(audio.currentTime + 0.2);
    }
};
